import { render, staticRenderFns } from "./genderBarChart.vue?vue&type=template&id=d10fdfd4&scoped=true"
import script from "./genderBarChart.vue?vue&type=script&lang=js"
export * from "./genderBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10fdfd4",
  null
  
)

export default component.exports